import React, { useState, useEffect } from "react";
import { database } from "../../firebaseConfig"; // Adjust the path as needed
import { ref, get, set } from "firebase/database";

const CategoryMetaForm = () => {
    const [metaData, setMetaData] = useState({
        title: "",
        description: "",
        keywords: ""
    });

    // Fetch meta data from Firebase on component mount
    useEffect(() => {
        const fetchMetaData = async () => {
            try {
                const metaRef = ref(database, "categoryMeta");
                const snapshot = await get(metaRef);
                if (snapshot.exists()) {
                    setMetaData(snapshot.val());
                }
            } catch (error) {
                console.error("Error fetching meta data:", error);
            }
        };

        fetchMetaData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setMetaData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await set(ref(database, "categoryMeta"), metaData);
            alert("Meta data saved successfully!");
        } catch (error) {
            console.error("Error saving meta data:", error);
            alert("Error saving meta data. Please try again.");
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{ maxWidth: "500px" }}>
            <div >
                <label style={{ display: "block", marginBottom: "5px" }}>Meta Title:</label>
                <input
                    type="text"
                    name="title"
                    value={metaData.title}
                    onChange={handleChange}
                    required
                    style={{ width: "100%", padding: "8px" }}
                />
            </div>
            <div style={{ marginBottom: "15px" }}>
                <label style={{ display: "block", marginBottom: "5px" }}>Meta Description:</label>
                <textarea
                    name="description"
                    value={metaData.description}
                    onChange={handleChange}
                    required
                    rows="3"
                    style={{ width: "100%", padding: "8px" }}
                />
            </div>
            <div style={{ marginBottom: "15px" }}>
                <label style={{ display: "block", marginBottom: "5px" }}>Meta Keywords:</label>
                <input
                    type="text"
                    name="keywords"
                    value={metaData.keywords}
                    onChange={handleChange}
                    required
                    style={{ width: "100%", padding: "8px" }}
                />
            </div>
            <button type="submit" style={{ padding: "10px 15px", cursor: "pointer" }}>
                Submit
            </button>
        </form>
    );
};

export default CategoryMetaForm;
